import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const countReportList = createSlice({
  name: "countReportList",
  initialState,
  reducers: {
    addCountRepportList: (state, action) => {
      state.data = action.payload;
    },
    updateTableRow: (state, action) => {

      const updatedRow = action.payload;
      const index = state.tableData.data.findIndex(
        (data) => data?.id === updatedRow?.id
      );
      state.tableData.data[index] = updatedRow;
    },
  },
});

export const { addCountRepportList,updateTableRow } = countReportList.actions;
export default countReportList.reducer;
